import {
  IconButton as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
  styled,
  Tooltip,
  type TooltipProps,
} from "@mui/material";

const StyledIconButton = styled(MuiIconButton, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  width: 30,
  height: 30,
  padding: 8,
  transition: "all 0.30s ease",
  borderRadius: "4px",
  border: "1px solid",
  borderColor: theme.palette.divider,
  backgroundColor: isSelected
    ? theme.palette.secondary.main
    : theme.palette.support[50],
  color: isSelected ? theme.palette.support[50] : theme.palette.secondary.main,
  "&:hover": {
    backgroundColor: isSelected
      ? theme.palette.secondary[800]
      : theme.palette.support[200],
  },
  "&:active": {
    backgroundColor: isSelected
      ? theme.palette.secondary.main
      : theme.palette.support[100],
  },
  ".MuiSvgIcon-root": {
    fontSize: 18,
  },
}));

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { IconButtonProps } from '@monthly/ui' */
export interface IconButtonProps extends MuiIconButtonProps {
  isSelected?: boolean;
  tooltip: string;
  /**
   * The placement of the tooltip relative to the button.
   * @default "bottom-start"
   */
  tooltipPlacement?: TooltipProps["placement"];
}

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { IconButton } from '@monthly/ui' */
export function IconButton({
  isSelected = false,
  children,
  onClick,
  tooltip,
  tooltipPlacement = "bottom-start",
  sx,
  ...props
}: IconButtonProps) {
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
  };

  return (
    <Tooltip title={tooltip} placement={tooltipPlacement}>
      <span>
        <StyledIconButton
          disableRipple
          disableFocusRipple
          onClick={handleOnClick}
          isSelected={isSelected}
          sx={sx}
          {...props}
        >
          {children}
        </StyledIconButton>
      </span>
    </Tooltip>
  );
}
